var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgParties = function SvgParties(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.86 443.17L134.37 459.74",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.65 451.29L153.55 330.86",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.52 179.33C194.8 174.8 182.08 170.27 182.08 170.27L138.3 264.51C132.68 276.62 131.82 290.31 136.15 298.75C136.15 298.75 144.04 318.33 156.84 322.88C169.64 327.44 187.33 316.98 187.34 316.98C196.03 313.18 204.02 302.03 207.32 289.09L232.97 188.39C232.97 188.39 220.25 183.86 207.53 179.33H207.52Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.22 251.44H216.9",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.52 133.7L253.6 165.63C267.42 183.95 276.29 205.37 279.14 227.29C280.36 236.72 282.58 247.22 286.41 258.38C295.53 284.99 308.71 300.48 345.2 347.4C356.96 362.52 354.52 358.68 378.26 390.12",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.85 113.83L279.93 145.76C293.75 164.08 311.91 178.5 332.19 187.26C340.92 191.03 350.41 196.05 360.08 202.79C383.16 218.88 394.43 235.8 429.51 283.78C440.81 299.24 437.79 295.84 461.5 327.31",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.24 390.11C383.27 396.78 405.98 388.14 428.98 370.79C451.97 353.45 466.53 333.98 461.5 327.32",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.43 345.27C349.46 351.94 372.17 343.3 395.17 325.95C418.16 308.61 432.72 289.14 427.69 282.48",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.14 287.86C306.17 294.53 328.88 285.89 351.88 268.54C374.87 251.2 389.43 231.73 384.4 225.07",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.39 139.83L264.19 107.54",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.83 113.09L241.59 90.6401",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.12 133.7L95.32 106.11L68.81 90.3198L96.4 76.5198L112.19 50.0098L125.99 77.5998L152.5 93.3898L124.91 107.19L109.12 133.7Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 459.74L271.7 432.15L245.19 416.36L272.78 402.56L288.56 376.05L302.37 403.64L328.87 419.43L301.28 433.23L285.5 459.74Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M391 174.32L377.2 146.73L350.69 130.95L378.28 117.15L394.07 90.6401L407.87 118.23L434.38 134.01L406.79 147.82L391 174.32Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgParties);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/parties.svg";